import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Storage } from '@ionic/storage';
import { advertisement, ServiceService } from '../service.service';
import { EmailComposer } from '@ionic-native/email-composer/ngx';

import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-detallesvacante',
  templateUrl: './detallesvacante.page.html',
  styleUrls: ['./detallesvacante.page.scss' , '../../assets/scss/styles.scss'],
})
export class DetallesvacantePage implements OnInit {
  idWorkoffer;
  workOffer: WorkOffer;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();

  constructor(
    public services: ServiceService,
    public storage: Storage,
    private activatedRoute: ActivatedRoute,
    private emailComposer: EmailComposer,
    private firebaseAnalytics: FirebaseAnalytics
  ) {
    this.firebaseAnalytics.logEvent;
    this.firebaseAnalytics.setCurrentScreen("Vacantes");
   }

  async ngOnInit() {
    // console.log("ngOnInit()");
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(7,1);
      this.advertisements.SizePage = 355;
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
    this.idWorkoffer = this.activatedRoute.snapshot.paramMap.get('id');
    // console.log("this.idWorkoffer", this.idWorkoffer);

    this.services.workOfferById(this.idWorkoffer).subscribe(
      data => {
        this.workOffer = data;
      },
        error => {
        console.log(error);
      }
    );
  }

  async scrollingAds(event:any) {
    let rows = Math.floor(Number(event.detail.scrollTop-this.advertisements.SizePage)/this.advertisements.SizeDivImage);
    let final = rows+this.advertisements.Rows;
    if(event.detail.scrollTop > this.advertisements.SizePage && rows>0 && final > this.advertisements.Displayed.length && this.advertisements.Displayed.length < this.advertisements.MediaBasico.length){
      let displayedLength = this.advertisements.Displayed.length;
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,final);
      let disply = this.advertisements.Displayed.slice(displayedLength,this.advertisements.Displayed.length);
      this.services.postAdvertisementUser(this.advertisements.getRelAdsMetricsId(disply));
    }
  }

  public mail() {
    const apps = 'correo';
    const cuerpo = `Buen día, envío mi CV para revisión.`;
    const email = {
      to: 'rhcomuncnc@grupohitec.com',
      cc: [],
      attachments: [],
      subject: 'CV para la vacante ' + this.workOffer.workOffer1,
      body: cuerpo,
      isHtml: false,
      app: apps
    };
    this.emailComposer.open(email);
/*
    setTimeout(() => { alert(`Estimado Candidat@

De parte de todo el equipo de GRUPO HITEC agradecemos su interés por formar parte de nuestra familia. Le notificamos que hemos recibido su CV de manera exitosa. Uno de nuestros reclutadores se comunicará con usted para darle seguimiento a la solicitud y poderle brindar el apoyo en el proceso de reclutamiento. 

¡Saludos!`) }, 4000);*/
  }

  openWhatsapp(){
    let message:string = 'Buen día, envío mi CV para revisión.';
    this.services.openFrame(`${this.workOffer?.whatsapp}`);
  } 
}

export class WorkOffer { 
  constructor(
   public id?: number,
   public workOffer1?: string,
   public profile?: string,
   public companyId?: number,
   public active?: number,
   public createdAt?: string,
   public modifiedAt?: string,
   public company?: string,
   public workplace?: string,
   public responsability?: string,
   public ability?: string,
   public knowledge?: string,
   public context?: string,
   public imageUrl?: any,
   public companyNavigation?: any,
   public postulates?: any[],
   public company1?: any,
   public whatsapp?: string,
  ) {}
 }

 
